import $ from 'jquery';
import videojs from 'video.js';

import autoplayMenuSectionTemplate from 'bundles/videojs/layout/autoplayMenuSection.html';

const KEY_TAB = 9;
const KEY_ENTER = 13;
const KEY_SPACE = 32;

class AutoplayMenuSection extends videojs.getComponent('MenuItem') {
  constructor(player, options) {
    super(player, options);
    $(this.el_).find('[data-js="autoplay-off-button"]').click(this.onAutoplayOff.bind(this));
    $(this.el_).find('[data-js="autoplay-on-button"]').click(this.onAutoplayOn.bind(this));
    $(this.el_)
      .find('[data-js="autoplay-on-button"]')
      .keydown((e) => {
        this.handleKeyPress(e);
      });

    this.one(player, 'ready', function () {
      if (player.autoplay()) {
        $(this.el_)
          .find('[data-js="autoplay-on-button"]')
          .addClass('selected')
          .attr('aria-label', 'Autoplay On Selected');
      } else {
        $(this.el_)
          .find('[data-js="autoplay-off-button"]')
          .addClass('selected')
          .attr('aria-label', 'Autoplay Off Selected');
      }
    });
  }

  createEl(type, props) {
    return $(autoplayMenuSectionTemplate())[0];
  }

  onAutoplayOff(type, props) {
    $(this.el_)
      .find('[data-js="autoplay-off-button"]')
      .addClass('selected')
      .attr('aria-selected', 'true')
      .attr('aria-label', 'Autoplay Off Selected');
    $(this.el_)
      .find('[data-js="autoplay-on-button"]')
      .removeClass('selected')
      .attr('aria-selected', 'false')
      .attr('aria-label', 'Autoplay On');
    this.player_.autoplay(false);
    this.player_.trigger('autoplaychange');
  }

  onAutoplayOn(type, props) {
    $(this.el_)
      .find('[data-js="autoplay-off-button"]')
      .removeClass('selected')
      .attr('aria-selected', 'false')
      .attr('aria-label', 'Autoplay Off');
    $(this.el_)
      .find('[data-js="autoplay-on-button"]')
      .addClass('selected')
      .attr('aria-selected', 'true')
      .attr('aria-label', 'Autoplay On Selected');
    this.player_.autoplay(true);
    this.player_.trigger('autoplaychange');
  }

  closeAndFocus() {
    const { settingsMenuButton } = this.player_.controlBar;
    settingsMenuButton.menu.unlockShowing();
    settingsMenuButton.el().focus();
    settingsMenuButton.el().classList.remove('selected');
  }

  handleKeyPress(e) {
    const autoplayOnButton = $(this.el).find('[data-js=autoplay-on-button]')[0];
    // only close settings menu when last item loses focus
    if (e.keyCode === KEY_TAB && !e.shiftKey && document.activeElement === autoplayOnButton) {
      this.closeAndFocus();
      e.stopPropagation();
    } else if (e.keyCode === KEY_ENTER || e.keyCode === KEY_SPACE) {
      this.onAutoplayOn.bind(this);
    } else {
      super.handleKeyPress(e);
    }
  }
}

videojs.registerComponent('AutoplayMenuSection', AutoplayMenuSection);
